import { useEffect, useState } from 'react';

import Checkbox from '../../../components/checkbox';

import { SIC_CODES } from '../../../lib/applications/sic-codes';
import SmallPill from '../../../components/pills/pill-small';

import { AddButton, DeleteButton } from '../../../components/buttons';

import MediaQuery from 'react-responsive';

const Dropdown = ({ title = 'Example', children }) => {
    const [ toggled, setToggled ] = useState(false);

    return (
        <div className="global-dropdown">
            <div className="global-dropdown__head">
                { title }
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" style={{ transform: toggled ? 'rotate(270deg)' : 'rotate(90deg)' }} onClick={() => setToggled(!toggled)}>
                    <g id="Ellipse_68" data-name="Ellipse 68" fill="#61707f" stroke="#64707e" stroke-width="1">
                        <circle cx="17.5" cy="17.5" r="17.5" stroke="none"/>
                        <circle cx="17.5" cy="17.5" r="17" fill="none"/>
                    </g>
                    <g id="Button_-_Arrow" data-name="Button - Arrow" transform="translate(15.707 12.5)">
                        <path id="Path_2" data-name="Path 2" d="M11.5,45.5l-5,5.586L1.5,45.5" transform="translate(-45.5 11.5) rotate(-90)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </g>
                </svg>
            </div>
            { toggled && <div className="global-dropdown__content">
                { children }    
            </div>}
        </div>
    )
}

const Sections = ({ mobile = false, sections, addSelectedSection, selectedSections }) => {
    return (
        <div class="question-type-sic__outer question-type-sic__sections">
            { !mobile && <p class="question-type-sic__title">Refine your section choice</p> }
            <div class="question-type-sic__content">
                { sections.map(({ name }) => {
                    return <Checkbox text={name} onChange={() => addSelectedSection(name)} checked={selectedSections.includes(name)}/>
                })}
            </div>
        </div>
    )
}

function generateLightColorHsl() {
  const hue = Math.floor(Math.random() * 360);
  const saturation = Math.floor(Math.random() * (100 + 1)) + "%";
  const lightness = Math.floor((1 + Math.random()) * (100/2 + 1)) + "%";
  return "hsl(" + hue + ", " + saturation + ", " + lightness + ")";
}

const Sectors = ({ mobile = false, filteredSections, params, onComponentChange }) => {
    console.log(filteredSections)
    return (
        <div class="question-type-sic__outer question-type-sic__sectors">
            { !mobile && <p class="question-type-sic__title">Select your applicable sector(s)</p> }
            <div class="question-type-sic__content">
                { filteredSections.length > 0 ? filteredSections.map(({ name, sectors })=> {
                    const color = generateLightColorHsl();

                    return (
                        <div className='question-type-sic-content__group'> 
                            <p className="question-type-sic-content-group__title">{ name }</p>
                            <div className="question-type-sic-content-group__content">
                                {
                                    sectors.map(sector => {
                                        let sec = `${name} - ${sector}`;

                                        return (
                                            <div className="question-type-sic__section">
                                                { sector }
                                                { !params?.value?.includes(sec) ?
                                                    <AddButton mobile={true} onClick={() => onComponentChange(sec)} />:
                                                    <DeleteButton mobile={true} onClick={() => onComponentChange(sec)} />
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                }) : <p>No sections selected (Filter to see sectors)</p>}
            </div>
        </div>
    )
}

export default function QuestionTypeSicCode({ question, params, onChange, validation, addError, error, showErrors, setValidation, handleQuestionChange, getQuestionValue, blockId, sectionId }) {    
    const [ selectedSections, setSelectedSections ] = useState([]);
    
    const onComponentChange = (sector) => {
        const value = getQuestionValue(sectionId, blockId, question.id) || [];

        let sectors = [ ...value ]

        if (sectors.includes(sector)) {
            sectors = sectors.filter(s => s !== sector);
        } else {
            sectors.push(sector);
        }

        onChange({ value: sectors });

        setError(sectors);
    }

    const setError = (e = null) => {
        let val = e !== null ? e : '';

        if (e !== null) {
            if (e.hasOwnProperty('value')) {
                val = e.value;
            }
        }

        if (question.response_required) {
            addError(val.length == 0, ['You need to select an option'], sectionId, question.id);
        }
    }

    const addSelectedSection = (name) => {
        let sections = [ ...selectedSections ];

        if (sections.includes(name)) {
            sections = sections.filter(s => s !== name);
        } else {
            sections.push(name);
        }

        setSelectedSections(sections);
    }

    const setSections = () => {
        const value = getQuestionValue(sectionId, blockId, question.id) || [];

        // We create a new set as it removes duplicate entries
        
        const sectionsSet = new Set(value.map(section => section.split(' - ')[0]));
        const sections = Array.from(sectionsSet);


        setSelectedSections(sections);
    }

    useEffect(() => {
        setError(params.value);

        setSections();
        
    }, [])

    const filteredSections = SIC_CODES.sections.filter(({ name }) => selectedSections.includes(name));

    return (
        <div className="section-content__container question-type__sic">
            { params.label && <p className="section-content__label">{ params.label || 'SIC Codes - Filter Lists' } </p> }
            
            <div className="section-content__container">
                { params.description && <p className="section-content__label">{ question.description || 'Your business sector selection using Gov.uk SIC codes click here to find out more' }</p> }

                <div className="question-type-sic__codes">
                    { params?.value?.map((sector) => {
                        return <SmallPill removable={true} onRemoveClick={() => onComponentChange(sector)}>{ sector }</SmallPill>
                    })}
                </div>
            </div>

            <div class="question-type-sic__container">
                <MediaQuery minWidth='992px'>
                    <Sections sections={SIC_CODES.sections} addSelectedSection={addSelectedSection} selectedSections={selectedSections}/>
                    <Sectors filteredSections={filteredSections} params={params} onComponentChange={onComponentChange}/>
                </MediaQuery>
                <MediaQuery maxWidth='992px'>
                    <Dropdown title="Refine your section choice">
                        <Sections mobile={true} sections={SIC_CODES.sections} addSelectedSection={addSelectedSection} selectedSections={selectedSections}/>
                    </Dropdown>
                    <Dropdown title="Select your applicable sector(s)">
                        <Sectors mobile={true} filteredSections={filteredSections} params={params} onComponentChange={onComponentChange}/>
                    </Dropdown>
                </MediaQuery>
            </div>

            { showErrors && error.length > 0 &&
                <div className="section-content__errors">
                    { error.map(err => <p className="section-content__error">{ err }</p>)}
                </div>
            }
        </div>
    )
}